/**
 * Shared Twilio utility functions used by both client and server.
 */

/**
 * Known Twilio demo/default URLs that indicate an unconfigured phone number.
 * These are assigned by Twilio when a number is first purchased or has no webhook set.
 */
const TWILIO_DEFAULT_URL_PATTERNS = ['demo.twilio.com'];

/**
 * Checks if a voice_url is a Twilio default/demo URL (i.e., the number is unconfigured).
 */
export const isTwilioDefaultUrl = (url: string | null | undefined): boolean => {
  if (!url || url.trim() === '') {
    return true;
  }
  return TWILIO_DEFAULT_URL_PATTERNS.some((pattern) => url.includes(pattern));
};
